import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import { ListItemGraphic} from 'rmwc/List';
import ReactTooltip from 'react-tooltip'

class AboutCentaTQ extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		question: '',
    		activeDiv: 0
    	}
	}

	handleQuestion = (e, value) => {
		this.setState({activeDiv: value})
	}

	handleRegister = (e) => {
		this.props.history.push('/portal/app/tq_registration/TQ/new/0')
	}

	handleTPOJump = (e) => {
		this.props.history.push('/portal/app/user/about/tpo')
	}

	handleTQJump = (e) => {
		this.props.history.push('/portal/app/user/about/tq')
	}

	handleMCJump = (e) => {
		this.props.history.push('/portal/app/user/about/mc')
	}

	render() {
		let handleQuestion = this.handleQuestion
		let handleTPOJump = this.handleTPOJump
		let handleRegister = this.handleRegister
		let handleTQJump = this.handleTQJump
		let handleMCJump = this.handleMCJump
		let tqLogo = 'https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/TQ_logo.png'

		return (
			<div>
				<Grid>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleTPOJump(e))}>CENTA TPO</Button>
					</GridCell>
					<GridCell span = "3">
					</GridCell>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleTQJump(e))}>CENTA TQ</Button>
					</GridCell>
					<GridCell span = "3">
					</GridCell>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleMCJump(e))}>CENTA MC</Button>
					</GridCell>
					<GridCell span="12">
					</GridCell>
					<GridCell span="4">
					</GridCell>
					<GridCell span="4">
						<img className ="tpoLogo" src={tqLogo} alt="logo" />
					</GridCell>
					<GridCell span="4">
					</GridCell>
					<GridCell span="5">
					</GridCell>
					<GridCell span="2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleRegister(e))}>Register</Button>
					</GridCell>
					<GridCell span="5">
					</GridCell>
					<div hidden>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 1))}>
								<Typography use="headline7"><b>What is CENTA TQ?</b></Typography>
								<div className={ this.state.activeDiv === 1 ? "showdiv" : "hidediv"} >
								  	<p>
								  		CENTA Teaching Quotient (TQ) is a score for teacher recruitment, based on a high-quality, online assessment of key competencies for teaching.
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 2))}>
								<Typography use="headline7"><b>What are the benefits of CENTA TQ?</b></Typography>
								<div className={ this.state.activeDiv === 2 ? "showdiv" : "hidediv"} >
								  	<p>
								  		CENTA TQ provides teaching professionals with an excellent opportunity to showcase their competencies, improve placement prospects and gain access to career opportunities with renowned schools that recognize talent.
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 3))}>
								<Typography use="headline7"><b>How does the TQ process look like?</b></Typography>
								<div className={ this.state.activeDiv === 3 ? "showdiv" : "hidediv"} >
								  	<ul>
							  			<li>Register on MyCENTA, choose your preferred track and test date. Save your details and complete the payment of the registration fee.</li>
							  			<li>We will schedule a 10 minute demo test to check your PC system requirements.</li>
							  			<li>You will receive an email two days prior to the test with all the relevant information.</li>
							  			<li>On the day of the TQ, you will take up the test online using the “invite code” at the scheduled time.</li>
							  			<li>Your TQ scorecard will be available on your MyCENTA account within two weeks.</li>
							  			<li>You will receive an email from us with a listing of schools you would want to share your TQ score with. You can choose your preferred schools and we will share your TQ score with them.</li>
							  		</ul>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 4))}>
								<Typography use="headline7"><b>What is the format of the test?</b></Typography>
								<div className={ this.state.activeDiv === 4 ? "showdiv" : "hidediv"} >
								  	<p>Fully technology enabled, TQ is conducted online and <b>you can take it from anywhere</b>. All you need is a laptop/desktop with a working webcam and a Smartphone.</p>
								  	<ul>
								  		<li>90-minute multiple-choice question test comprising 50 questions: Subject Understanding (20), Teaching Practices (20) and Professional Competencies (10).</li>
								  		<li>15-minute Written Communication exercise (essay on a generic topic).</li>
								  		<li>15-minute Verbal Communication exercise (two self-videos on given topics).</li>
								  	</ul>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 5))}>
								<Typography use="headline7"><b>What is the syllabus of the test?</b></Typography>
								<div className={ this.state.activeDiv === 5 ? "showdiv" : "hidediv"} >
								  	<p>
								  		For Subject Understanding, the <b>test is board-agnostic and applicable for all boards</b> (CBSE, ICSE, State Boards, IB, IGCSE, etc.). However, the topics tested are broadly (but not exclusively) aligned to the<b> NCERT curriculum</b> and focuses mainly on conceptual understanding and application of the topics.<br /> Questions on Teaching Practices focus on <b>understanding and application of common classroom techniques</b>. Several situation-based questions are used to make the test practice-oriented.
										<br/>The questions on Professional Competencies will <b>cover classroom communication and management, teamwork and understanding of education policies.</b><br />
										For Written and Verbal Communication, the participants will be given general, non-academic topics to write about and speak on, respectively.
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 6))}>
								<Typography use="headline7"><b>Which all subjects is the TQ available in?</b></Typography>
								<div className={ this.state.activeDiv === 6 ? "showdiv" : "hidediv"} >
									<p>
										<ul>
											<li>Early Childhood Education</li>
											<li>Primary School English</li>
											<li>Primary School Maths</li>
											<li>English as a Second Language**</li>
										</ul>
										<ul>
											<li>Middle School English</li>
											<li>Middle School Maths</li>
											<li>Middle School Science</li>
											<li>Middle School Social Studies</li>
										</ul>
										<ul>
											<li>Secondary School Biology</li>
											<li>Secondary School Chemistry</li>
											<li>Secondary School Physics</li>
											<li>Secondary School Maths</li>
											<li>Secondary School English</li>
										</ul>
										<ul>
											<li>Senior Secondary School Biology</li>
											<li>Senior Secondary School Chemistry</li>
											<li>Senior Secondary School Physics</li>
											<li>Senior Secondary School Maths</li>
											<li>Senior Secondary School English</li>
											<li>Senior Secondary School Economics</li>
											<li>Senior Secondary School Accountancy</li>
										</ul>
										<ul>
											<li>Elementary School Computer Science (Class 1 to 8)</li>
											<li>Secondary School Computer Science (Class 9 to 12)</li>
										</ul>
									</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 7))}>
								<Typography use="headline7"><b>When will the TQ be held?</b></Typography>
								<div className={ this.state.activeDiv === 7 ? "showdiv" : "hidediv"} >
								  	<p>
								  		The next TQ will be held on April 12, 2020
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 8))}>
								<Typography use="headline7"><b>What is the registration fee for CENTA TQ?</b></Typography>
								<div className={ this.state.activeDiv === 8 ? "showdiv" : "hidediv"} >
							  		<p>
							  			The registration fee for the TQ test is INR 1900 + GST per subject track.
									</p>
							  	</div>
							</Card>
						</GridCell>
					</div>
				</Grid>
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutCentaTQ);


// WEBPACK FOOTER //
// ./src/views/about/AboutCentaTQ.jsx